import { Input } from 'antd'
import { SubmitButton } from 'components/form/FormActionBar'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import { bindQueryParam } from 'views/AppLocals/functions/routerHelper'
import { doc_addReferenceLinks_Api } from '../../apis'
import ApiInfoForm from '../../components/form/ApiInfoForm'
import FieldDecorator from '../../components/form/FieldDecorator'
import { createValue } from '../../components/form/utils'

export const KeywordAddLink = ({ document_id, keyword, onClose }) => {
  const t = useTranslate()
  return (
    <ApiInfoForm
      disableNotify={false}
      onSuccess={() => {
        onClose()
      }}
      initialValues={{
        value: keyword,
        url: null,
      }}
      query={bindQueryParam({ id: document_id })}
      apiInfo={doc_addReferenceLinks_Api}>
      {({
        isSubmitting,
        dirty,
        isValid,
        values = {},
        validate,
        handleChange,
        handleSubmit,
        ...props
      }) => (
        <div className="flex flex-col">
          <FieldDecorator label="url">
            <Input
              name={'url'}
              type={'url'}
              onChange={(e) => {
                handleChange(createValue('url', e.target.value))
              }}
            />
          </FieldDecorator>
          <div className="flex w-full justify-end float-right py-3">
            <SubmitButton dirtyRequired={false} />
          </div>
        </div>
      )}
    </ApiInfoForm>
  )
}

export default KeywordAddLink
